"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoExtendingRental = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RoExtendingRental = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    /**
     * Do not include $, but format as a currency value 0.00
     */
    rental_extension_fee: typebox_1.Type.String(),
    /**
     * Pickup date if there is one, otherwise leave it as an empty string
     */
    extension_end_date: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
});
//# sourceMappingURL=ro-extending-rental.js.map